import arrowStartSvg from "../../../assets/images/icons/arrow_start.svg";
import arrowEndSvg from "../../../assets/images/icons/arrow_end.svg";
import { formatDate } from "../../../utils/common";

function DonationListPc({
  data,
  totalCount,
  currentPage,
  pageSize,
  onPageChange,
  renderStatus,
}) {
  const totalPages = Math.ceil(totalCount / pageSize);

  const renderPagination = () => {
    const pages = [];
    const start = Math.floor((currentPage - 1) / 10) * 10 + 1;

    for (let i = start; i < start + 10 && i <= totalPages; i++) {
      pages.push(
        <li
          className={currentPage === i ? "on" : ""}
          key={i}
          onClick={() => onPageChange(i)}
        >
          {i}
        </li>
      );
    }

    return (
      <ul className="pagination">
        {start > 1 && (
          <li onClick={() => onPageChange(start - 1)}>
            <img src={arrowStartSvg} alt="" />
          </li>
        )}
        {pages}
        {start + 10 <= totalPages && (
          <li onClick={() => onPageChange(start + 10)}>
            <img src={arrowEndSvg} alt="" />
          </li>
        )}
      </ul>
    );
  };

  return (
    <div className="product-list-pc">
      <table>
        <thead>
          <tr>
            <th>상품명</th>
            <th>결제일</th>
            <th>금액</th>
            <th>결제 유형</th>
            <th width="130px"></th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, i) => {
            return (
              <tr key={i}>
                <td>
                  <span>
                    {item.donation_type === "subscription"
                      ? "정기후원"
                      : "일반결제"}
                  </span>
                </td>
                <td>{formatDate(item.payment_date)}</td>
                <td>{Number(item.amount).toLocaleString()}원</td>
                <td>
                  {item.donation_type === "subscription" ? (
                    <span className="not-use">정기결제</span>
                  ) : (
                    <span className="success-use">일반결제</span>
                  )}
                </td>
                <td>
                  {item.donation_type === "subscription" &&
                    renderStatus(
                      item.subscription_info.subscription_status,
                      item.billing_subscription_id
                    )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {renderPagination()}
    </div>
  );
}

export default DonationListPc;
